import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import React from "react";
import StarIcon from "../icons/StarIcon";
import Iconify from "../iconify/iconify";
import useWindowSize from "../../hooks/useWindowSize";
import Image from "../image/image";

const StyledTeamBox = styled(Box)(({ theme }) => ({
  padding: "30px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  textAlign: "center",
}));

const StyledTwitterBox = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  width: "70px",
  background: "#a95052",
  textAlign: "center",
  borderRadius: "50px",
  position: "absolute",
  bottom: "-10px",
  margin: "0 auto",
  left: 0,
  right: 0,
}));

const StyledTelegramBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: `1px solid ${theme.palette.divider}`,
  padding: "10px 10px 12px 20px",
  borderRadius: "50px",
  background: theme.palette.background.main,
}));

const StyledSentBox = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  width: "35px",
  height: "35px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#a95052",
}));

const Team = () => {
  const screenWidth = useWindowSize();
  return (
    <Stack py={5} spacing={2}>
      <Box mb={2}>
        <StarIcon />
      </Box>

      <Typography variant="h3" color="text.secondary">
        Nuestro equipo de trabajo e inversionistas
      </Typography>

      <Grid container spacing={2} paddingRight={4} justifyContent="center">
        {TeamFakeData.map((item, i) => (
          <Grid
            item
            key={i}
            xs={screenWidth < 700 ? 12 : 4}
            md={4}
            lg={screenWidth > 1500 ? 6 : 2.4}
            xl={2.4}
          >
            <StyledTeamBox>
              <Box position="relative" width="100%">
                <Image src={item.img} alt="Team member" ratio="1/1" sx={{ maxWidth: "230px", maxHeight: "230px" }}/>
              </Box>
            </StyledTeamBox>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default Team;

const TeamFakeData = [
  {
    id: 0,
    img: "/assets/about/plusvalica.png",
    twitterLink: "https://twitter.com",
    fullName: "Max Mitchell",
    postion: "Founder",
    telegramLink: "https://t.me/settings",
  },
  {
    id: 0,
    img: "/assets/about/GTGROUP-ELEMENTOS_-03.png",
    twitterLink: "https://twitter.com",
    fullName: "Sarah Johnson",
    postion: "Chief Real Estate Officer",
    telegramLink: "https://t.me/settings",
  },
  {
    id: 0,
    img: "/assets/about/plusvalrewards.png",
    twitterLink: "https://twitter.com",
    fullName: "David Brown",
    postion: "Head of Property Management",
    telegramLink: "https://t.me/settings",
  },
  {
    id: 0,
    img: "/assets/about/paramont-brokers.png",
    twitterLink: "https://twitter.com",
    fullName: "Michael Turner",
    postion: "Legal Counsel",
    telegramLink: "https://t.me/settings",
  },
  {
    id: 0,
    img: "/assets/about/ideasreward.png",
    twitterLink: "https://twitter.com",
    fullName: "Michael Turner",
    postion: "Legal Counsel",
    telegramLink: "https://t.me/settings",
  },
];
